
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'V2PlanCardSkeleton'
})
